import makeTransitionComponent from 'components/base/appear_transition';

const component = makeTransitionComponent('animated fadeInRight');

export default component;
